import type { Tenant } from "shared/types";
import TenantCard from "./TenantCard";
import TenantUpload from "./TenantUpload";

interface ReportGridProps {
  tenants: Tenant[];
  onDocumentUpload?: (tenantId: string) => void;
  onServiceManagement?: (tenantId: string, tenantName: string) => void;
}

const TenantGrid = ({ tenants, onDocumentUpload, onServiceManagement }: ReportGridProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6 mx-10">
      <TenantUpload />
      {tenants.map((report,index) => (
        <TenantCard
          key={report.id}
          tenant={report}
          onDocumentUpload={onDocumentUpload}
          onServiceManagement={onServiceManagement}
          index={index}
        />
      ))}
    </div>
  );
};

export default TenantGrid;
